"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderingManager = void 0;
const domain_id_1 = require("@streem/domain-id");
const toolbox_1 = require("@streem/toolbox");
const rxjs_1 = require("rxjs");
class RenderingManager {
    constructor(context) {
        this.context = context;
        this.bufferPropertiesSubject = new rxjs_1.BehaviorSubject(undefined);
        this.bufferProperties = this.bufferPropertiesSubject.asObservable();
        this.bufferCanvas = context.compositor.buffer;
        this.cameraFrame = context.compositor.cameraFrame;
    }
    /**
     * fulfillStreemshotRequestsForWeb will create a subscription which listens for the latest Streemshot request.
     * On a valid request, it will obtain Blob data from the target canvas
     * and invoke fulfillStreemshot on the RoomSession's streemshot controller.
     * Returns a function that unsubscribes from the subscription.
     */
    fulfillStreemshotRequestsForWeb() {
        const streemshotFulfillmentSubscription = this.context.streemshotEngine
            .fulfillStreemshotRequestsForWeb({
            localUser: this.context.roomSession.user.localUser,
            latestStreemshotRequest: this.context.roomSession.streemshots.latestRequest,
            streemshots: this.context.roomSession.streemshots.responses,
            canvas: this.bufferCanvas,
        })
            .subscribe(([request, blob]) => __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(request.streemshotId, "request's streemshotId must be defined");
            yield this.context.roomSession.streemshots.fulfillStreemshot(new domain_id_1.StreemshotRequestId(request.id), new domain_id_1.StreemshotId(request.streemshotId), blob, {
                width: this.bufferCanvas.width,
                height: this.bufferCanvas.height,
            });
        }));
        // Return a function to unsubscribe when the call ends.
        return () => streemshotFulfillmentSubscription.unsubscribe();
    }
    renderVideoForUser() {
        const targetCanvas = createCanvasInContainer(this.context.container);
        const targetContext = targetCanvas.getContext('2d', { alpha: false });
        (0, toolbox_1.invariant)(targetContext, 'Unable to get 2D context');
        const renderSignalSubscription = this.context.compositor.renderSignal.subscribe(() => {
            this.drawBufferToTarget(targetCanvas, targetContext);
        });
        const disconnectCompositor = this.context.compositor.connect();
        return () => {
            if (disconnectCompositor) {
                disconnectCompositor();
            }
            if (renderSignalSubscription) {
                renderSignalSubscription.unsubscribe();
            }
            targetCanvas.remove();
        };
    }
    drawBufferToTarget(target, targetContext) {
        var _a, _b;
        // Resize the target canvas to match the buffer canvas
        if (target.width !== this.bufferCanvas.width ||
            target.height !== this.bufferCanvas.height) {
            target.width = this.bufferCanvas.width;
            target.height = this.bufferCanvas.height;
        }
        // Draw image from buffer canvas onto the target canvas
        targetContext.drawImage(this.bufferCanvas, 0, 0);
        const { width: targetWidth, height: targetHeight } = target;
        if (targetWidth !== ((_a = this.bufferPropertiesSubject.value) === null || _a === void 0 ? void 0 : _a.width) ||
            targetHeight !== ((_b = this.bufferPropertiesSubject.value) === null || _b === void 0 ? void 0 : _b.height)) {
            this.bufferPropertiesSubject.next({
                width: targetWidth,
                height: targetHeight,
            });
        }
    }
}
exports.RenderingManager = RenderingManager;
function createCanvasInContainer(container) {
    const target = document.createElement('canvas');
    // fill the canvas parent conatiner while maintaining the video aspect ratio
    target.style.objectFit = 'contain';
    target.style.height = '100%';
    target.style.width = '100%';
    // do not display the context menu.
    target.addEventListener('contextmenu', event => {
        event.preventDefault();
        return false;
    });
    container.appendChild(target);
    container.addEventListener('contextmenu', event => {
        event.preventDefault();
        return false;
    });
    return target;
}
//# sourceMappingURL=rendering_manager.js.map